module.exports = __webpack_public_path__ + "static/media/arrow_down_filling.eab78fac.svg";